import React from 'react';

import { SVGPropsType } from 'src/types';

const Share = (props: SVGPropsType) => {
    const { fill, onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M13.9997 8.80001C13.5997 8.80001 13.333 9.06668 13.333 9.46668V12.6667C13.333 13.0667 13.0663 13.3333 12.6663 13.3333H3.33301C2.93301 13.3333 2.66634 13.0667 2.66634 12.6667V3.33334C2.66634 2.93334 2.93301 2.66668 3.33301 2.66668H6.53301C6.93301 2.66668 7.19967 2.40001 7.19967 2.00001C7.19967 1.60001 6.93301 1.33334 6.53301 1.33334H3.33301C2.19967 1.33334 1.33301 2.20001 1.33301 3.33334V12.6667C1.33301 13.8 2.19967 14.6667 3.33301 14.6667H12.6663C13.7997 14.6667 14.6663 13.8 14.6663 12.6667V9.46668C14.6663 9.06668 14.3997 8.80001 13.9997 8.80001Z"
                fill={fill}
            />
            <path
                d="M14.6003 1.73334C14.5337 1.60001 14.4003 1.46668 14.267 1.40001C14.2003 1.33334 14.067 1.33334 14.0003 1.33334H10.0003C9.60033 1.33334 9.33366 1.60001 9.33366 2.00001C9.33366 2.40001 9.60033 2.66668 10.0003 2.66668H12.4003L8.86699 6.20001C8.60033 6.46668 8.60033 6.86668 8.86699 7.13334C9.00033 7.26668 9.20033 7.33334 9.33366 7.33334C9.46699 7.33334 9.66699 7.26668 9.80033 7.13334L13.3337 3.60001V6.00001C13.3337 6.40001 13.6003 6.66668 14.0003 6.66668C14.4003 6.66668 14.667 6.40001 14.667 6.00001V2.00001C14.667 1.93334 14.667 1.80001 14.6003 1.73334Z"
                fill={fill}
            />
        </svg>
    );
};

export default Share;
